export * from './depot-overview-card-loading-skeleton.component';
